<template>
  <div class="insure-page">
    <div class="page-top">
      <h2 class="page-title">保险公司合同管理</h2>
      <el-button type="primary" icon="el-icon-plus" @click="openAdd">新增合同</el-button>
    </div>

    <el-table
      v-loading="loading"
      :data="tableData"
      border
      stripe
      empty-text="暂无数据"
      :header-cell-style="headerCellStyle"
    >
      <el-table-column prop="index" label="序号" width="70" align="center" />
      <el-table-column prop="company" label="保险公司" min-width="140" show-overflow-tooltip />
      <el-table-column prop="startDate" label="合作起期" min-width="110" />
      <el-table-column prop="endDate" label="合作至期" min-width="110" />
      <el-table-column prop="typeName" label="合作模式" min-width="90" align="center" />
      <el-table-column prop="fee" label="授权费用" min-width="100" />
      <el-table-column prop="currency" label="币种" width="80" align="center" />
      <el-table-column label="协议" width="90" align="center">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.contractPaper"
            type="text"
            size="small"
            @click="downloadPaper(scope.row)"
          >下载</el-button>
          <span v-else class="muted">无</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="140" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="openEdit(scope.row)">编辑</el-button>
          <el-button type="text" size="small" @click="removeContract(scope.row)">删除</el-button>
        </template>
      </el-table-column>
      <el-table-column label="服务" width="110" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="openPlanService(scope.row)">编辑服务</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      :title="editMode ? '编辑合同' : '新增合同'"
      :visible.sync="dialogVisible"
      width="640px"
      @close="resetForm"
    >
      <el-form ref="formRef" :model="form" :rules="rules" label-width="140px">
        <el-form-item label="签约保险公司" prop="relatedInstitute">
          <el-select
            v-model="form.relatedInstitute"
            filterable
            placeholder="请选择保险公司"
            style="width: 100%"
            :disabled="editMode"
          >
            <el-option
              v-for="item in regulatorOptions"
              :key="item.id"
              :label="item.name"
              :value="String(item.id)"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="合作模式" prop="type">
          <el-select v-model="form.type" placeholder="请选择合作模式" style="width: 100%">
            <el-option label="大包" value="1" />
            <el-option label="小包" value="2" />
            <el-option label="纯服务" value="3" />
          </el-select>
        </el-form-item>
        <el-form-item label="合作期限" prop="dates">
          <el-date-picker
            v-model="form.dates"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item label="上传合作协议">
          <el-upload action="#" :show-file-list="false" :http-request="uploadContractPaper">
            <el-button size="small" type="primary" :loading="uploading">选择文件</el-button>
            <span v-if="form.contractPaper" class="upload-ok">已上传</span>
          </el-upload>
        </el-form-item>
        <el-form-item label="国内案件费用" prop="domestic">
          <el-select v-model="form.domestic" placeholder="请选择" style="width: 100%">
            <el-option label="3500" value="3500" />
          </el-select>
        </el-form-item>
        <el-form-item label="国外案件费用" prop="foreignLimit">
          <el-select v-model="form.foreignLimit" placeholder="请选择" style="width: 100%">
            <el-option label="6000" value="6000" />
            <el-option label="7000" value="7000" />
            <el-option label="9000" value="9000" />
          </el-select>
        </el-form-item>
        <el-form-item label="整体加收幅度">
          <el-select v-model="form.entitrAdded" placeholder="请选择" style="width: 100%">
            <el-option label="5%" value="5" />
            <el-option label="6%" value="6" />
            <el-option label="7%" value="7" />
            <el-option label="20%" value="20" />
          </el-select>
        </el-form-item>
        <el-form-item label="授权费用">
          <el-input v-model="form.authurizedFree" placeholder="授权指挥中心权限/费用" style="width: 200px" />
          <el-select v-model="form.currency" placeholder="币种" style="width: 120px; margin-left: 12px">
            <el-option label="RMB" value="RMB" />
            <el-option label="USD" value="USD" />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitting" @click="submitForm">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="编辑计划服务" :visible.sync="serviceVisible" width="640px">
      <div v-loading="serviceLoading" class="service-check-list">
        <el-checkbox-group v-model="selectedServiceIds">
          <el-checkbox
            v-for="item in serviceOptions"
            :key="item.id"
            :label="Number(item.id)"
            class="service-check-item"
          >{{ item.name }}</el-checkbox>
        </el-checkbox-group>
      </div>
      <span slot="footer">
        <el-button @click="serviceVisible = false">取消</el-button>
        <el-button type="primary" :loading="serviceSaving" @click="savePlanService">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import constants from "@/util/constants.js";
import {
  wListContracts,
  wListRegulatorInstiByContract,
  wAddOrUpdateContract,
  wDelContract,
  wGetContract,
  wGetPlanService,
  wUpdatePlanService,
} from "@/views/axios/api.js";
import {
  normalizeContractList,
  isBizJson,
  insureRequestAuth,
} from "@/util/insureApiCompat.js";

/**
 * 保险公司合同管理
 */
export default {
  name: "InsureContractManage",
  data() {
    return {
      token:
        this.$route.params.token ||
        JSON.parse(window.localStorage.getItem("data") || "{}").data,
      loading: false,
      submitting: false,
      uploading: false,
      dialogVisible: false,
      editMode: false,
      tableData: [],
      regulatorOptions: [],
      form: this.createEmptyForm(),
      rules: {
        relatedInstitute: [{ required: true, message: "请选择保险公司", trigger: "change" }],
        type: [{ required: true, message: "请选择合作模式", trigger: "change" }],
        dates: [{ required: true, message: "请选择合作期限", trigger: "change" }],
        domestic: [{ required: true, message: "请选择国内案件费用", trigger: "change" }],
        foreignLimit: [{ required: true, message: "请选择国外案件费用", trigger: "change" }],
      },
      serviceVisible: false,
      serviceLoading: false,
      serviceSaving: false,
      currentPlanId: "",
      serviceOptions: [],
      selectedServiceIds: [],
      headerCellStyle: {
        background: "#f5f7fb",
        color: "#303133",
        fontWeight: "600",
      },
    };
  },
  mounted() {
    this.loadList();
  },
  methods: {
    /**
     * @returns {Object} 空表单
     */
    createEmptyForm() {
      return {
        id: "",
        relatedInstitute: "",
        type: "1",
        dates: [],
        contractPaper: "",
        domestic: "",
        foreignLimit: "",
        entitrAdded: "5",
        authurizedFree: "",
        currency: "RMB",
      };
    },

    /**
     * 加载合同列表（兼容 HTML / JSON）
     */
    loadList() {
      this.loading = true;
      wListContracts({ token: this.token })
        .then((res) => {
          var normalized = normalizeContractList(res.data);
          if (normalized.code === -1) {
            this.$message.error(normalized.msg || "加载失败");
            this.tableData = [];
            return;
          }
          if (normalized.code !== 0) {
            this.$message.error(normalized.msg || "加载失败，错误号：" + normalized.code);
            this.tableData = [];
            return;
          }
          this.tableData = normalized.list;
        })
        .catch(() => {
          this.$message.error("加载合同列表失败");
        })
        .finally(() => {
          this.loading = false;
        });
    },

    /**
     * 加载未签合约的保险公司
     * @param {string|number} [keepInstiId] 编辑时保留当前机构
     */
    loadRegulatorOptions(keepInstiId) {
      var params = { token: this.token };
      if (keepInstiId) params.instiId = keepInstiId;
      return wListRegulatorInstiByContract(params).then((res) => {
        if (!isBizJson(res.data) || Number(res.data.code) !== 0) {
          this.regulatorOptions = [];
          return;
        }
        this.regulatorOptions = res.data.obj || [];
      });
    },

    /**
     * 打开新增弹窗
     */
    openAdd() {
      this.editMode = false;
      this.resetForm();
      this.loadRegulatorOptions().then(() => {
        this.dialogVisible = true;
      });
    },

    /**
     * 打开编辑弹窗并回填
     * @param {Object} row 表格行
     */
    openEdit(row) {
      if (!row.id) {
        this.$message.warning("未获取到合同ID");
        return;
      }
      this.editMode = true;
      this.resetForm();
      Promise.all([
        this.loadRegulatorOptions(row.relatedInstitute),
        wGetContract({ token: this.token, id: row.id }),
      ]).then((results) => {
        var res = results[1];
        if (!isBizJson(res.data) || Number(res.data.code) !== 0) return;
        var contract = res.data.obj || {};
        var extra = res.data.obj2 || {};
        var plan = extra.plan || {};
        this.form = {
          id: contract.id || row.id,
          relatedInstitute: String(contract.relatedInstitute || row.relatedInstitute || ""),
          type: String(contract.type || "1"),
          dates: [extra.startDate || row.startDate, extra.endDate || row.endDate],
          contractPaper: contract.contractPaper || row.contractPaper || "",
          domestic: plan.domestic != null ? String(plan.domestic) : "",
          foreignLimit: plan.foreignLimit != null ? String(plan.foreignLimit) : "",
          entitrAdded: plan.entitrAdded != null ? String(plan.entitrAdded) : "5",
          authurizedFree: plan.authurizedFree != null ? String(plan.authurizedFree) : "",
          currency: plan.currency || "RMB",
        };
        this.dialogVisible = true;
      });
    },

    /**
     * 重置表单
     */
    resetForm() {
      this.form = this.createEmptyForm();
      if (this.$refs.formRef) this.$refs.formRef.clearValidate();
    },

    /**
     * 上传地址：必须同域，Request Headers.Cookie 才能带上 rescue_account_token
     * （与旧站 api 域内表单上传一致；URL 绝不拼 ?token=）
     * @returns {string}
     */
    resolveUploadUrl() {
      var isDev =
        process.env.NODE_ENV === "development" ||
        /^(localhost|127\.0\.0\.1)$/i.test(window.location.hostname);
      // 开发：走 webpack 代理 /rescue → API，浏览器会自动带本站 Cookie
      if (isDev) return "/rescue/user/upload_file";
      try {
        var api = new URL(constants.domain);
        // 前端与 API 同域（如旧站挂在 api.*.dajiuxing.com.cn）
        if (api.host === window.location.host) {
          return api.origin + "/rescue/user/upload_file";
        }
      } catch (e) {}
      // 生产有反向代理时同域；否则仍走相对路径（需网关把 /rescue 转到 API）
      return "/rescue/user/upload_file";
    },

    /**
     * 上传合作协议
     * POST multipart/form-data，字段 file1；
     * token 只放 Request Headers → Cookie: rescue_account_token=...（不跟在 URL 后）
     * @param {{file: File}} option el-upload 参数
     */
    uploadContractPaper(option) {
      var token = this.token || "";
      var form = new FormData();
      form.append("file1", option.file);

      /**
       * 写入本站 Cookie；同域请求时浏览器自动放进 Request Headers.Cookie
       * 与截图一致：Cookie: rescue_account_token=xxx
       */
      var auth = insureRequestAuth({ token: token });

      var uploadUrl = this.resolveUploadUrl();

      this.uploading = true;
      axios
        .post(uploadUrl, form, {
          // 不手动设 Content-Type，浏览器自动带 multipart boundary
          headers: Object.assign({}, auth.headers || {}),
        })
        .then((res) => {
          if (!isBizJson(res.data) || Number(res.data.code) !== 0) {
            this.$message.error((res.data && res.data.msg) || "上传失败");
            return;
          }
          this.form.contractPaper = res.data.obj;
          this.$message.success("上传成功");
        })
        .catch(() => {
          this.$message.error("上传失败，请确认本地已重启（/rescue 代理生效）");
        })
        .finally(() => {
          this.uploading = false;
        });
    },

    /**
     * 提交合同（现网扁平字段）
     */
    submitForm() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return;
        if (!this.form.dates || this.form.dates.length !== 2) {
          this.$message.warning("请选择合作期限");
          return;
        }
        this.submitting = true;
        var payload = {
          token: this.token,
          id: this.form.id || "",
          relatedInstitute: this.form.relatedInstitute,
          type: this.form.type,
          startDate: this.form.dates[0],
          endDate: this.form.dates[1],
          contractPaper: this.form.contractPaper || "",
          domestic: this.form.domestic,
          foreignLimit: this.form.foreignLimit,
          entitrAdded: this.form.entitrAdded || "",
          authurizedFree: this.form.authurizedFree || "",
          currency: this.form.currency || "RMB",
        };
        wAddOrUpdateContract(payload)
          .then((res) => {
            if (!isBizJson(res.data) || Number(res.data.code) !== 0) return;
            this.$message.success(this.editMode ? "保存成功" : "新增成功");
            this.dialogVisible = false;
            this.loadList();
          })
          .finally(() => {
            this.submitting = false;
          });
      });
    },

    /**
     * 删除合同
     * @param {Object} row 表格行
     */
    removeContract(row) {
      if (!row.id) {
        this.$message.warning("未获取到合同ID");
        return;
      }
      this.$confirm("确认删除该合同？", "提示", { type: "warning" })
        .then(() => wDelContract({ token: this.token, id: row.id }))
        .then((res) => {
          if (!isBizJson(res.data) || Number(res.data.code) !== 0) return;
          this.$message.success("删除成功");
          this.loadList();
        })
        .catch(() => {});
    },

    /**
     * 下载协议文件
     * @param {Object} row 表格行
     */
    downloadPaper(row) {
      if (row.contractPaper) window.open(row.contractPaper);
    },

    /**
     * 打开计划服务编辑
     * @param {Object} row 表格行
     */
    openPlanService(row) {
      var planId = row.planId || row.relatedInstitute || row.id;
      if (!planId) {
        this.$message.warning("未找到计划ID");
        return;
      }
      this.currentPlanId = planId;
      this.serviceVisible = true;
      this.serviceLoading = true;
      wGetPlanService({ token: this.token, planId: planId })
        .then((res) => {
          if (!isBizJson(res.data) || Number(res.data.code) !== 0) return;
          this.serviceOptions = res.data.obj || [];
          this.selectedServiceIds = (res.data.obj2 || []).map(function (id) {
            return Number(id);
          });
        })
        .finally(() => {
          this.serviceLoading = false;
        });
    },

    /**
     * 保存计划服务勾选
     */
    savePlanService() {
      this.serviceSaving = true;
      wUpdatePlanService({
        token: this.token,
        planId: this.currentPlanId,
        ids: this.selectedServiceIds.join(","),
      })
        .then((res) => {
          if (!isBizJson(res.data) || Number(res.data.code) !== 0) return;
          this.$message.success("服务保存成功");
          this.serviceVisible = false;
        })
        .finally(() => {
          this.serviceSaving = false;
        });
    },
  },
};
</script>

<style scoped>
.insure-page {
  text-align: left;
  padding: 8px 8px 24px;
}
.page-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}
.page-title {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #303133;
}
.muted {
  color: #c0c4cc;
}
.upload-ok {
  margin-left: 10px;
  color: #67c23a;
  font-size: 13px;
}
.service-check-list {
  min-height: 120px;
  max-height: 420px;
  overflow: auto;
}
.service-check-item {
  display: block;
  margin: 8px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/cmd_center/pact.vue